import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_RESULT_SEARCH_AFFAIR = "SET_RESULT_SEARCH_AFFAIR";
export const SET_CURRENT_AFFAIR = "SET_CURRENT_AFFAIR";

export const SET_FILTERED_AND_SORTED_AFFAIRS = "SET_FILTERED_AND_SORTED_AFFAIRS";
export const SET_ALL_AFFAIRS = "SET_ALL_AFFAIRS";

export const SET_SELECTED_TYPE = "SET_AFFAIR_SELECTED_TYPE";
export const SET_SELECTED_STATE = "SET_AFFAIR_SELECTED_STATE";
export const SET_START_DATE = "SET_AFFAIR_START_DATE";
export const SET_END_DATE = "SET_AFFAIR_END_DATE";
export const SET_DISPLAY_ALL_AFFAIRS = "SET_DISPLAY_ALL_AFFAIRS";
export const SET_DISPLAY_AS_LIST = "SET_DISPLAY_AS_LIST";

export const AFFAIR_TYPE = "Affaire";
export const CONTRACT_TYPE = "Contrat";

export const SET_TOTAL_AMOUNT = "SET_AFFAIR_TOTAL_AMOUNT";

export const NB_MAX_AFFAIRS_TO_DISPLAY = 3;
